export default __webpack_public_path__ + "static/media/lightning-transition.7a6642af.gif";